import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import "./notifications.css"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group sonner-message group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.sonner-message]:text-muted-foreground",
          actionButton:
            "group-[.sonner-message]:bg-primary group-[.sonner-message]:text-primary-foreground",
          cancelButton:
            "group-[.sonner-message]:bg-muted group-[.sonner-message]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
